import React from 'react';
import { makeStyles, Modal } from "@material-ui/core";
import CouponAppliedBg from "../../assets/images/2_Applied_coupon_graphic.svg";
import ClearIcon from "@material-ui/icons/Clear";

const useStyles = makeStyles((theme) => ({
    couponAppliedModal: {
        padding: '44px 20px',
        '& h2': {
            marginTop: '80px !important',
            color: '#637381 !important',
            fontSize: '20px !important',
        },
        '& p': {
            fontSize: 32,
            color: '#4F4F4F',
            fontWeight: 'bold',
            textAlign: 'center',
            marginTop: 5,
            marginBottom: 20
        },
        '& div': {
            color: '#637381',
            fontSize: 14,
            textAlign: 'center'
        }
    },
    couponModal: {
        zIndex: '9999 !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    crossIcon: {
        position: 'absolute',
        right: 10,
        top: 10,
        cursor: 'pointer',
        color: '#757575'
    },
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: 0,
        boxShadow: theme.shadows[5],
        padding: '16px 30px',
        borderRadius: 8,
        outline: 'none !important',
        '& h2': {
            color: '#000',
            fontSize: 16,
            margin: 0,
            width: '100%',
            textAlign: 'center',
            padding: '20px 0',
        },
        '& > img': {
            width: '100%',
            position: 'absolute',
            left: 0,
            top: 0,
            padding: 10,
        },
        '@media (max-width: 767px)': {
            width: '90%',
            padding: '15px 20px',
        },
    },
}));
const CouponAppliedModel = props => {
    const classes = useStyles();
    const { isOpen, closeModel, selectedCoupon, selectedPlan } = props;
    const couponAppliedModal = (
        <div className={`${classes.paper} ${classes.couponAppliedModal}`}>
            <img src={CouponAppliedBg} alt=""/>
            <span onClick={closeModel} className={classes.crossIcon}>
                <ClearIcon/>
            </span>
            {
                selectedCoupon && selectedCoupon.couponCode ? <>
                    <h2>Code {selectedCoupon.couponCode} applied!</h2>
                    <p>₹{selectedPlan.discountViaCoupon}</p>
                    <div>saving with this coupon</div>
                </> : <><h2>This coupon code is not valid or used before. Try different code.</h2></>
            }
        </div>
    );
    return (
        <Modal
            open={isOpen}
            onClose={closeModel}
            className={classes.couponModal}>
            {couponAppliedModal}
        </Modal>
    );
};

export default CouponAppliedModel;
